import { PlaceToVisitItem } from '@/src/types/seoSrpResult'
import { Box, Card, Chip, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

interface PlacesToVisitProps {
    heading: string
    places: PlaceToVisitItem[]
}

const PlacesToVisit: React.FC<PlacesToVisitProps> = ({ heading, places }) => {
    return (
        <Box sx={{ mb: 3 }}>
            {heading && (
                <Typography
                    component="h2"
                    variant="h6"
                    sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 2 }}
                >
                    {heading}
                </Typography>
            )}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
                    gap: 2
                }}
            >
                {places.map((place, index) => (
                    <Card
                        key={index}
                        sx={{
                            p: 2,
                            borderRadius: 1.5,
                            border: 1,
                            borderColor: 'grey.200',
                            boxShadow: 'none'
                        }}
                    >
                        <Chip
                            size="small"
                            label={place.category}
                            sx={{
                                mb: 1.5,
                                textTransform: 'capitalize',
                                bgcolor: 'grey.100',
                                fontSize: '0.75rem'
                            }}
                        />
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                            {place.name}
                        </Typography>
                        <RichText html={place.description} variant="body2" sx={{ color: 'text.secondary' }} />
                    </Card>
                ))}
            </Box>
        </Box>
    )
}

export default PlacesToVisit
export type { PlacesToVisitProps }
